import { render } from "./404.vue?vue&type=template&id=a807821c&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=a807821c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a807821c"

export default script